var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "3", "ma-1": "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("reviews")]),
              _vm._v(" Review\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: { block: "", href: _vm.overviewUrl },
                            },
                            [_vm._v("Overview")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                block: "",
                                href: _vm.detailedReviewsUrl,
                              },
                            },
                            [_vm._v("Detailed Review")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                block: "",
                                href: _vm.guestReviewsUrl,
                                disabled: "",
                                href: "",
                              },
                            },
                            [_vm._v("Guest Reviews")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                block: "",
                                disabled:
                                  !_vm.hotel.bookable_via_iescape &&
                                  !_vm.hotel.bookable_via_partner &&
                                  !_vm.hotel.bookable_via_direct,
                                href: _vm.starRatingsUrl,
                              },
                            },
                            [_vm._v("Star Ratings")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                block: "",
                                disabled:
                                  !_vm.hotel.bookable_via_iescape &&
                                  !_vm.hotel.bookable_via_partner &&
                                  !_vm.hotel.bookable_via_direct,
                                href: _vm.awardsUrl,
                                disabled: "",
                                href: "",
                              },
                            },
                            [_vm._v("Awards")]
                          ),
                          _vm._v(" "),
                          _vm.isTailormadeTour
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "mt-1",
                                  attrs: {
                                    block: "",
                                    href: _vm.operatorWriteupsUrl,
                                  },
                                },
                                [_vm._v("Operator Writeup")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }